/* eslint-disable */
// react-router-dom components
import { Link } from "react-router-dom";

// @mui material components
import Grid from "@mui/material/Grid";

// Soft UI Dashboard PRO React components
import SuiBox from "components/SuiBox";
import SuiTypography from "components/SuiTypography";
import SuiButton from "components/SuiButton";

// Soft UI Dashboard PRO React example components
import DefaultNavbar from "examples/Navbars/DefaultNavbar";
import PageLayout from "examples/LayoutContainers/PageLayout";

// Soft UI Dashboard PRO React base styles
import typography from "assets/theme/base/typography";

// Authentication layout components
import Footer from "layouts/authentication/components/Footer";

// Soft UI Dashboard PRO React page layout routes
import pageRoutes from "pageRoutes";

// Images
import error404 from "assets/images/illustrations/error-404.png";

function Error403() {
  const { d1, d3, d4, d5 } = typography;

  return (
    <PageLayout white>
      {/* <DefaultNavbar
        routes={pageRoutes}
        transparent
        action={{
          type: "external",
          route: "https://creative-tim.com/product/soft-ui-dashboard-pro-material-ui",
          label: "buy now",
          color: "dark",
        }}
      /> */}
      <SuiBox my={24} height="calc(100vh - 24rem)">
        <Grid container spacing={3} justifyContent="center" alignItems="center" className="h-100">
          <Grid item xs={11} sm={9} container alignItems="center">
            <Grid item xs={12} lg={6}>
              <SuiBox
                fontSize={{ xs: d5.fontSize, sm: d4.fontSize, md: d3.fontSize, lg: d1.fontSize }}
                lineHeight={1.2}
              >
                <SuiTypography variant="inherit" textColor="error" textGradient fontWeight="bold">
                  Unouthorized
                </SuiTypography>
              </SuiBox>
              <SuiTypography variant="h2" textColor="dark" textGradient fontWeight="bold">
                You are not authorized to access this resource
              </SuiTypography>
              <SuiBox mt={1} mb={2}>
                <SuiTypography variant="body1" textColor="text">
                  We suggest you to go to the homepage while we solve this issue.
                </SuiTypography>
              </SuiBox>
              <SuiBox mt={4} mb={2}>
                <SuiButton
                  component={Link}
                  to="/myslr/projects-list"
                  variant="gradient"
                  buttonColor="dark"
                >
                  go to homepage
                </SuiButton>
              </SuiBox>
            </Grid>
            <Grid item xs={12} lg={6}>
              <SuiBox component="img" src={error404} alt="error-404" width="100%" />
            </Grid>
          </Grid>
        </Grid>
      </SuiBox>
      <Footer />
    </PageLayout>
  );
}

export default Error403;
